// extracted by mini-css-extract-plugin
module.exports = {"pageMargin":"style__pageMargin__zO8eh","notice":"style__notice__gi8dw"};